// src/components/PrivateRoute.js
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { user, loading } = useContext(AuthContext);
  if (loading) {
    return "loading...";
  }
  return user ? <Component /> : <Navigate to="/login" />;
};

export default PrivateRoute;
